import { toRem } from "./"
import { phone, fromDesktop, tablet } from "./media"

export default {
  colors: {
    title: "#2F2F2F",
    text: "#575757",
    image: "#FFFFFF",
    link: "#FF7500",
    darker: "#000",
    lightGray: "#EAEAEA",
    gray: "#797979",
    sideBarGray: "#F0F0F0"
  },
  breakpoints: [toRem(phone), toRem(phone), toRem(tablet), toRem(fromDesktop)],
  variants: {
    title: {
      pb: "6rem",
      pt: "6rem"
    },
    document: {
      fontSize: toRem(18)
    }
  }
}
